import React from 'react';
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import TextArea from "../src/components/textArea/TextArea";
import styled from "styled-components";
import Colors from "../src/constants/Colors";
import {deviceMax} from '../styles/device';
import WaveLayout from '../src/layouts/WaweLayout';

const Kisisel: NextPage = () => {
    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Kişisel Veriler | Pembe Panjur'}
                description={'Pembe Panjur kişisel veriler ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}
            />

            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={false}
                        hamburgerMenuType={'black'} registerButton={true}>
                <PersonalWrapper>
                    <TextArea>
                        <h2>KİŞİSEL VERİLERİN KORUNMASI</h2>
                        <p>
                            İşbu Gizlilik Politikası’nın amacı, Pembe Panjur tarafından işletilmekte olan
                            www.pembepanjur.com internet sitesi ve hangi işletim sistemi üzerinde çalıştığı fark
                            etmeksizin mobil uygulamalar da dâhil mevcut durumda ve ileride kullanılacak tüm platformlar
                            (“Platform”) üzerinden temin ettiği hizmetler sırasında, Platform kullanıcıları (“Üye”)
                            tarafından Pembe Panjur ile paylaşılan veya Pembe Panjur’un Üye’nin Platform’u kullanımı
                            sırasında ürettiği kişisel verilerin kullanımına ilişkin koşul ve şartları tespit etmektir.
                        </p>

                        <p style={{fontWeight: "bold"}}>
                            Üye, işbu Gizlilik Politikası’nı kabul ederek kişisel verilerinin işlenmesine ilişkin olarak
                            aydınlatılmış olduğunu ve kişisel verilerinin burada belirtilen şekilde kullanımına
                            muvafakat ettiğini beyan eder.
                        </p>

                        <h3>
                            Hangi Veriler İşlenmektedir?
                        </h3>

                        <p>
                            İşbu başlık altında, Pembe Panjur tarafından işlenen ve Kişisel Verilerin Korunması Kanunu
                            uyarınca kişisel veri sayılan verilerin hangileri olduğu sıralanmıştır. Aksi açıkça
                            belirtilmedikçe, işbu Gizlilik Politikası kapsamında arz edilen hüküm ve koşullar kapsamında
                            “kişisel veri” ifadesi aşağıda yer alan bilgileri kapsayacaktır.
                        </p>

                        <ol style={{paddingLeft: 17}}>
                            <li className={'listMarkerPink'}>
                                Kimlik Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                İletişim Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                Müşteri Bilgisi
                            </li>

                            <li className={'listMarkerPink'}>
                                Müşteri İşlem Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                İşlem Güvenliği Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                Finansal Bilgi
                            </li>
                            <li className={'listMarkerPink'}>
                                Hukuki İşlem ve Uyum Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                Denetim ve Teftiş Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                Pazarlama Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                Ürün/Hizmet Kullanım Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                Talep/Şikâyet Yönetimi Bilgisi
                            </li>
                            <li className={'listMarkerPink'}>
                                Olay Yönetimi Bilgisi
                            </li>

                        </ol>

                        <p>
                            Üye, Pembe Panjur’a ilettiği bilgi ve belgeler kapsamında kendisine ait din ve ırk bilgisi,
                            sağlık verisi ile fotoğrafı nedeniyle elde edilen biyometrik veriler ve kılık kıyafet
                            verileri gibi verilerinin de Pembe Panjur tarafından işlenmekte olduğunu kabul eder. Bahsi
                            geçen veriler “özel nitelikli kişisel veri” olup, Üye bu verilerinin işbu Gizlilik
                            Politikası kapsamında belirtilen amaçlarla işlenmesine açıkça muvafakat etmektedir.
                        </p>
                        <p>
                            Pembe Panjur, Üye’nin Platform’u kullanımı ile ilgili bilgileri teknik bir iletişim dosyası
                            olan çerezleri (Cookie) kullanarak elde edebilmekte olup, Platform üzerinde sunulmakta olan
                            hizmetlere erişim ve kullanım alışkanlıklarının tespit edilmesi için çerez yoluyla IP
                            bilgileri toplanmaktadır.

                        </p>
                        <p>
                            6698 Sayılı Kişisel Verilerin Korunması Kanunu’nun 3 ve 7. maddesi dairesince, geri
                            döndürülemeyecek şekilde anonim hale getirilen veriler, anılan kanun hükümleri uyarınca
                            kişisel veri olarak kabul edilmeyecek ve bu verilere ilişkin işleme faaliyetleri işbu
                            Gizlilik Politikası hükümleri ile bağlı olmaksızın gerçekleştirecektir.

                        </p>

                        <h3>
                            Veriler Hangi Amaçlarla Kullanılmaktadır?

                        </h3>
                        <p>
                            Pembe Panjur, Üye tarafından sağlanan kişisel verileri, üyelik kaydının gerçekleştirilmesi
                            ile bunu takiben Üye’ye taahhüt edilen hizmetlerin sağlanması amacı ile kullanacaktır. Pembe
                            Panjur ayrıca, bahsi geçen kişisel verileri sunduğu hizmetlerin iyileştirilmesi, hizmetin
                            geliştirilmesi ve bu kapsamda Üye’ye gerekli bilgilendirilmelerin yapılması ve sunduğu
                            hizmetlerin doğasından kaynaklanan yükümlülüklerin yerine getirilmesi için işleyebilir.

                        </p>
                        <p>
                            Söz konusu kişisel bilgiler Üye ile temas kurmak veya Üye’nin Platform’daki tecrübesini
                            iyileştirmek (mevcut hizmetlerin geliştirilmesi, yeni hizmetler oluşturulması ve kişiye özel
                            hizmetler sunulması gibi) amacıyla kullanılabileceği gibi, Pembe Panjur raporlama ve iş
                            geliştirme faaliyetleri kapsamında kullanılabilecek, Üye’nin kimliği ifşa edilmeden çeşitli
                            istatistiksel değerlendirmeler yapma, veri tabanı oluşturma ve pazar araştırmalarında
                            bulunma amacıyla da kullanılabilecektir. Üye’nin ayrıca onay vermesi halinde onay kapsamında
                            söz konusu bilgiler Pembe Panjur ve işbirliğinde olduğu kişiler tarafından doğrudan
                            pazarlama yapmak amacıyla işlenebilecek, saklanabilecek, üçüncü kişilere iletilebilecek ve
                            söz konusu bilgiler üzerinden çeşitli uygulama, ürün ve hizmetlerin tanıtımı, bakım ve
                            destek faaliyetlerine ilişkin bildirimlerde bulunma amacıyla Üye ile iletişime
                            geçilebilecektir.

                        </p>
                        <p>
                            Pembe Panjur ayrıca, Kişisel Verilerin korunması Kanunu’nun 5 ve 8. maddeleri uyarınca
                            ve/veya ilgili mevzuattaki istisnaların varlığı halinde kişisel verileri Üye’nin ayrıca
                            rızasını almaksızın işleyebilecek ve üçüncü kişilerle paylaşabilecektir. Bu durumların
                            başlıcaları aşağıda belirtilmiştir:

                        </p>
                        <ol>
                            <li className="listMarkerPink">
                                Kanunlarda açıkça öngörülmesi,
                            </li>
                            <li className="listMarkerPink">
                                Fiili imkânsızlık nedeniyle rızasını açıklayamayacak durumda bulunan veya rızasına
                                hukuki geçerlilik tanınmayan kişinin kendisinin ya da bir başkasının hayatı veya beden
                                bütünlüğünün korunması için zorunlu olması,

                            </li>
                            <li className="listMarkerPink">
                                Üye ile Pembe Panjur arasında herhangi bir sözleşmenin kurulması veya ifasıyla doğrudan
                                doğruya ilgili olması kaydıyla, kişisel verilerin işlenmesinin gerekli olması,
                            </li>
                            <li className="listMarkerPink">
                                Hukuki yükümlülüklerin yerine getirebilmesi için zorunlu olması,
                            </li>
                            <li className="listMarkerPink">
                                Üye’nin kendisi tarafından alenileştirilmiş olması,
                            </li>
                            <li className="listMarkerPink">
                                Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması,
                            </li>
                            <li className="listMarkerPink">
                                Üye’nin temel hak ve özgürlüklerine zarar vermemek kaydıyla, Pembe Panjur’un meşru
                                menfaatleri için veri işlenmesinin zorunlu olması.
                            </li>
                        </ol>

                        <p>
                            Yukarıda da belirtildiği üzere Pembe Panjur, çerez (Cookie) kullanabilecek ve bu kapsamda
                            veri işleyerek üçüncü kişiler tarafından sunulan analiz hizmetleri kapsamında işlenmesi
                            amacıyla sadece bu analiz hizmetlerinin gerektirdiği ölçüde kullanılması amacıyla üçüncü
                            kişilere iletebilecektir. Bahsi geçen teknik iletişim dosyaları, ana bellekte saklanmak
                            üzere Platform tarafından Üye’nin tarayıcısına (browser) gönderdiği küçük metin
                            dosyalarıdır. Çerezler bir platform hakkında durum ve tercih ayarlarını saklayarak, bazı
                            durumlarda uygulama ya da sitenin kullanımı açısında zaruri bilgileri kaydeder bazen ise
                            benzer bilgileri sonraki oturumlarda kullanılmak üzere saklamak suretiyle platformların
                            kullanımını kolaylaştırır. Çerezler, internet sitelerini zamansal oranlamalı olarak kaç
                            kişinin kullandığını, bir kişinin herhangi bir internet sitesini hangi amaçla, kaç kez
                            ziyaret ettiği ve ne kadar kaldığı hakkında istatistiksel bilgileri elde etmek ve
                            Kullanıcılar için özel tasarlanmış kullanıcı sayfalarından dinamik olarak reklam ve içerik
                            üretilmesine yardımcı olmak üzere tasarlanmış olup, bu amaçlarla da kullanılmaktadır. Bu
                            veriler dışında, çerezler vasıtasıyla cihaz ana belleğinden sair herhangi bir kişisel veri
                            toplanmamaktadır.
                        </p>
                        <p>
                            Bununla birlikte, web tarayıcılarının pek çoğu başta çerezleri kabul eder biçimde
                            tasarlanmıştır, ancak kullanıcılar dilerse çerezlerin gelmemesi veya çerez dosyasının
                            gönderildiğinde ikaz verilmesini sağlayacak biçimde tarayıcı ayarlarını her zaman için
                            değiştirebilirler.

                        </p>
                        <p>
                            Pembe Panjur çerezleri ayrıca, arama motorlarını, Platform’u veya Pembe Panjur’un anlaşmalı
                            olduğu üçünü parti platformları ziyaret ettiğinizde, kullanım alışkanlıklarınıza göre
                            ilginizi çekebilecek olan reklamları size sunmak amacıyla online davranışsal reklamcılık ve
                            pazarlama hizmetlerini uygulamak için kullanabilir. Pembe Panjur, anılan uygulamanın
                            yapılabilmesi amacıyla Üye’nin sitedeki davranışlarını tarayıcıda bulunan bir cookie (çerez)
                            ile ilişkilendirme ve görüntülenen sayfa sayısı, ziyaret süresi ve hedef tamamlama sayısı
                            gibi metrikleri temel alan yeniden pazarlama listeleri tanımlama hakkını haizdir. Daha sonra
                            Üye’ye Platform’da ya da görüntülü reklam ağındaki diğer mecralarda ilgi alanlarına göre
                            hedefe yönelik reklam içeriği gösterilebilir. Üye’nin tarayıcı vasıtasıyla çerezleri kabul
                            etmediği durumlarda da kendisine Platform veya anılan üçüncü platformlarda reklam
                            gösterilmeye devam edilecek fakat bu reklamlar Üye’nin kullanım alışkanlıklarına göre
                            konfigüre edilmiş reklamlar olmayacaktır.

                        </p>
                        <p>
                            Pembe Panjur, hizmet aldığı üçüncü kişiler vasıtasıyla mobil uygulamaları üzerinden Üye’ye
                            anlık bildirimler (push notification) gönderebilecektir. Üye, Pembe Panjur’dan anlık
                            bildirimler (push notificaion) almayı tercih etmezse mobil uygulama veya cihazı üzerinden
                            tercihlerini değiştirebilecektir.

                        </p>

                        <h3>
                            Verilere Kimler Erişebilmektedir?
                        </h3>
                        <p>
                            Pembe Panjur, Üye’ye ait kişisel verileri ve bu kişisel verileri kullanılarak elde ettiği
                            yeni verileri, Üye’ye karşı taahhüt ettiği edimlerin ifası amacıyla Pembe Panjur’un
                            hizmetlerinden faydalandığı üçüncü kişilere, söz konusu hizmetlerin temini amacıyla sınırlı
                            olmak üzere aktarılabilecektir.

                        </p>
                        <p>
                            Pembe Panjur ayrıca, Üye’den Platform’dan faydalanmasına ilişkin hizmet bedellerinin tahsil
                            edilmesi veya tahsilata ilişkin itiraz ve ihtilafların çözümlenmesi amacıyla Üye’nin ilgili
                            verilerini hizmet alınan ödeme hizmeti sağlayıcılarla paylaşabilecektir.

                        </p>
                        <p>
                            Pembe Panjur, Üye deneyiminin geliştirilmesi (iyileştirme ve kişiselleştirme dâhil), Üye’nin
                            güvenliğini sağlamak, hileli ya da izinsiz kullanımları tespit etmek, operasyonel
                            değerlendirme araştırılması, Platform veya Pembe Panjur hizmetlerine ilişkin hataların
                            giderilmesi ve işbu Gizlilik Politikası’nda yer alan amaçlardan herhangi birisini
                            gerçekleştirebilmek için SMS gönderimi yapanlar da dâhil olmak üzere dış kaynak hizmet
                            sağlayıcıları, barındırma hizmet sağlayıcıları (hosting servisleri), hukuk büroları,
                            araştırma şirketleri, çağrı merkezleri gibi üçüncü kişiler ile paylaşabilecektir.

                        </p>
                        <p>
                            Üye, yukarıda belirtilen amaçlarla sınırlı olmak kaydı ile bahsi geçen üçüncü tarafların
                            Üye’nin kişisel verilerini Avrupa Birliği’ndeki sunucularında saklayabileceğini, bu hususa
                            peşinen muvafakat ettiğini kabul eder.

                        </p>

                        <h3>
                            Verileri Toplamanın Yöntemi ve Hukuki Sebebi

                        </h3>
                        <p>
                            Pembe Panjur, Üye’nin kişisel verilerini işbu Gizlilik Politikası’nda belirtilen amaçlar ve
                            hukuki sebepler ile ilgili mevzuatta öngörülen veri işleme şartları ve amaçları
                            doğrultusunda, Platform üzerinden veya Üyeler’in sosyal medya hesapları üzerinden elektronik
                            ortamda toplayarak işleyebilir ve aktarabilir.

                        </p>
                        <h3>
                            Verilere Erişim Hakkı ve Düzeltme Talepleri Hakkında

                        </h3>
                        <p>
                            Üye, Pembe Panjur’a başvurarak kendisiyle ilgili;
                        </p>
                        <ol>
                            <li className="listMarkerPink">Kişisel veri işlenip işlenmediğini öğrenme,</li>
                            <li className="listMarkerPink">Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,
                            </li>
                            <li className="listMarkerPink">Kişisel verilerin işlenme amacını ve bunların amacına uygun
                                kullanılıp kullanılmadığını öğrenme,
                            </li>
                            <li className="listMarkerPink">Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı
                                üçüncü kişileri bilme,
                            </li>
                            <li className="listMarkerPink">Kişisel verilerin eksik veya yanlış işlenmiş olması halinde
                                bunların düzeltilmesini isteme,
                            </li>
                            <li className="listMarkerPink">İlgili mevzuatta öngörülen şartlar çerçevesinde kişisel
                                verilerin silinmesini veya yok edilmesini isteme,
                            </li>
                            <li className="listMarkerPink">İlgili mevzuat uyarınca yapılan düzeltme, silme ve yok edilme
                                işlemlerinin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
                            </li>
                            <li className="listMarkerPink">İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla
                                analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz
                                etme,
                            </li>
                            <li className="listMarkerPink">Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle
                                zarara uğraması halinde zararın giderilmesini talep etme,
                                haklarına sahiptir.
                            </li>
                        </ol>
                        <p>
                            Üye, yukarıda belirtilen taleplerini “Yeşilköy Mah. Atatürk Cad. No: 12/2 EGS Business Park
                            B3 Blok Ofis 264, Bakırköy 34149 - İstanbul” adresine yazılı olarak iletebilecektir. Pembe
                            Panjur, yukarıda yer alan talepler uyarınca, gerekçeli olumlu/olumsuz yanıtını, yazılı veya
                            dijital ortamdan gerçekleştirebilir. Taleplere ilişkin gerekli işlemler için ücret
                            alınmaması esastır. Bununla birlikte, işlemlerin bir maliyet gerektirmesi halinde, Kişisel
                            Verilerin Korunması Kurulu tarafından, Kişisel Verilerin korunması Kanunu’nun 13. maddesine
                            göre belirlenen tarife üzerinden ücret talep edilmesi mümkündür.

                        </p>
                        <p>
                            Üye, işbu Gizlilik Politikası’na konu bilgilerinin tam, doğru ve güncel olduğunu, bu
                            bilgilerde herhangi bir değişiklik olması halinde bunları derhal güncelleyeceğini taahhüt
                            eder. Üye’nin güncel bilgileri sağlamamış olması halinde Pembe Panjur’un herhangi bir
                            sorumluluğu olmayacaktır.

                        </p>
                        <p>
                            Üye, herhangi bir kişisel verisinin Pembe Panjur tarafından kullanılamaması ile sonuçlanacak
                            bir talepte bulunması halinde Pembe Panjur’un kendisine taahhüt ettiği hizmetlerden tam
                            olarak faydalanamayabileceğini kabul ile bu kapsamda doğacak her türlü sorumluluğun
                            kendisine ait olacağını beyan eder.

                        </p>

                        <h3>
                            Kişisel Verilerin Saklama Süresi
                        </h3>

                        <p>
                            Pembe Panjur, Üye tarafından sağlanan kişisel verileri, sunduğu hizmetlerin mahiyetinden
                            kaynaklanan yükümlülüklerin yerine getirilmesi amacıyla, hizmetlerin sağlandığı süre boyunca
                            saklayacaktır.

                        </p>
                        <p>
                            Buna ek olarak, Pembe Panjur, Üye ile arasında doğabilecek herhangi bir uyuşmazlık
                            durumunda, uyuşmazlık kapsamında gerekli savunmaların gerçekleştirilebilmesi amacıyla
                            sınırlı olmak üzere ve ilgili mevzuat uyarınca belirlenen zamanaşımı süreleri boyunca
                            kişisel verileri saklayabilecektir.

                        </p>

                        <h3>
                            Veri Güvenliğine İlişkin Önlemler ve Taahhütler

                        </h3>

                        <p>
                            Pembe Panjur, ilgili mevzuatta belirlenen veya işbu Gizlilik Politikası’nda ifade edilen
                            şartlarda,
                        </p>
                        <ol>
                            <li className="listMarkerPink">kişisel verilerin hukuka aykırı olarak işlenmesini,</li>
                            <li className="listMarkerPink">kişisel verilere hukuka aykırı olarak erişilmesini, ve</li>
                            <li className="listMarkerPink">kişisel verilerin muhafazasını sağlamak amacıyla uygun
                                güvenlik düzeyini temin etmeye yönelik gerekli teknik ve idari tedbirleri almayı,
                                gerekli denetimleri yaptırmayı
                                taahhüt eder.
                            </li>
                        </ol>

                        <p>
                            Pembe Panjur, Üye hakkında elde ettiği kişisel verileri bu işbu Gizlilik Politikası ve
                            Kişisel Verilerin Korunması Kanunu hükümlerine aykırı olarak başkasına açıklayamaz ve işleme
                            amacı dışında kullanamaz.

                        </p>
                        <p>
                            Platform üzerinden başka uygulamalara link verilmesi halinde, Pembe Panjur uygulamaların
                            gizlilik politikaları ve içeriklerine yönelik herhangi bir sorumluluk taşımamaktadır.

                        </p>

                        <h3>
                            Gizlilik Politikası’ndaki Değişiklikler

                        </h3>

                        <p>
                            Pembe Panjur, işbu Gizlilik Politikası hükümlerini dilediği zaman değiştirebilir. Güncel
                            Gizlilik Politikası, Üye’ye herhangi bir yöntemle sunulduğu tarihte yürürlük kazanır.

                        </p>
                    </TextArea>
                </PersonalWrapper>
            </WaveLayout>
        </React.Fragment>

    )
}

const PersonalWrapper = styled.div`
  position: relative;
  padding: 0 25px;
  margin-bottom: 44px;

  @media ${deviceMax.tablet} {
    padding: 70px 0 0 0;
    margin-bottom: 0;
  }

  > div {
    padding-left: 40px;
    padding-right: 40px;
  }

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    color: ${Colors.brandColor};

    @media ${deviceMax.tablet} {
      color: ${Colors.black};
      text-align: center;
      margin: 0 auto 24px;
    }
  }

  ol {
    padding-left: 15px;
  }

  .listMarkerPink {
    list-style: disc;

    &:first-child {
      margin-bottom: 0;
    }

    &:not(:first-child) {
      margin-top: 0;
      margin-bottom: 0;
    }

    p, span {
      margin-left: -17px;
      color: ${Colors.black};
    }

    &::marker {
      font-weight: bold;
    }
  }

  .listMarkerBold {
    &::marker {
      font-weight: bold;
    }
  }
`;

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default Kisisel;
